import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationCancel, NavigationError, ResolveEnd, ResolveStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { merge, Observable, Subject } from 'rxjs';
import { filter, mapTo } from 'rxjs/operators';
import { BaseComponent } from './shared/custom-components/base-component/base-component.component';
import { NgxBpRefreshService, RefreshSystemType } from '@biggerpicture/ngx-bp-refresh';
import { BiggerPictureMessagesService } from './shared/services/bigger-picture-messages.service';
import { MOI } from './shared/enums/moi.enum';
import { SystemMessagesEnum } from './shared/enums/system-messages.enum';
import { UiService } from './shared/services/ui.service';

@Component({
  selector: 'app-root',
  template: `
    <div *ngIf="isLoading$ |async" class="preload-loader-wrapper">
      <mat-spinner></mat-spinner>
    </div>
    <router-outlet></router-outlet>
  `,
  styleUrls: ['./app.components.scss']
})
export class AppComponent extends BaseComponent implements OnInit, OnDestroy {

  showLoader$: Observable<boolean>;
  hideLoader$: Observable<boolean>;
  isLoading$: Observable<boolean>;
  private unsubscribe = new Subject();

  constructor(
    public translate: TranslateService,
    private router: Router,
    private refreshService: NgxBpRefreshService,
    public biggerPictureMessagesService: BiggerPictureMessagesService,
    public uiService: UiService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.showLoader$ = this.router.events.pipe(
      filter((e) => e instanceof ResolveStart),
      mapTo(true)
    );
    this.hideLoader$ = this.router.events.pipe(
      // A resolver that errors or a cancelled navigation never fires ResolveEnd, which used to
      // leave this loader stuck forever (BIG-98) - also clear it on those outcomes.
      filter((e) => e instanceof ResolveEnd || e instanceof NavigationError || e instanceof NavigationCancel),
      mapTo(false)
    );
    this.isLoading$ = merge(this.showLoader$, this.hideLoader$);

    /**
     * Configure refresh service
     * - Run the service
     * - Apply translation for dialog
     */
    this.refreshService.run({
      type: RefreshSystemType.Admin,
      frequencyInSeconds: 15 * 60,
      skipConfirmationOnRoutes: ['/sales-monitor']
    });
    this.translate.onTranslationChange.subscribe(() => {
      this.refreshService.setDialogMessages({
        content: this.translate.instant(this.biggerPictureMessagesService.tranKey(MOI.SYSTEM, SystemMessagesEnum.RefreshDialogContent)),
        okBtn: this.translate.instant(this.biggerPictureMessagesService.tranKey(MOI.SYSTEM, SystemMessagesEnum.Ok)),
        cancelBtn: this.translate.instant(this.biggerPictureMessagesService.tranKey(MOI.SYSTEM, SystemMessagesEnum.Cancel)),
      });
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
  }

}
